module.exports = __webpack_public_path__ + "img/energy-1.2.fafa8d4b.svg";